import type { IThemeStorage } from "../interfaces/IThemeStorage";
import type { IThemeDOM } from "../interfaces/IThemeDOM";
import type { Theme, Mode } from "../types/theme.types";
import { DEFAULT_THEME, DEFAULT_MODE } from "../types/theme.types";

export class ThemeService {
	constructor(
		private readonly storage: IThemeStorage,
		private readonly dom: IThemeDOM,
	) {}

	getTheme(): Theme {
		return this.storage.getTheme();
	}

	setTheme(theme: Theme): void {
		this.storage.setTheme(theme);
		this.dom.setTheme(theme);
	}

	getMode(): Mode {
		return this.storage.getMode();
	}

	setMode(mode: Mode): void {
		this.storage.setMode(mode);
		this.dom.setMode(mode);
	}

	toggleMode(): Mode {
		const current = this.getMode();
		const newMode = current === "light" ? "dark" : "light";
		this.setMode(newMode);
		return newMode;
	}

	getSystemPreference(): Mode {
		return this.dom.getSystemPreference();
	}

	watchSystemPreference(callback: (mode: Mode) => void): () => void {
		return this.dom.watchSystemPreference(callback);
	}

	reset(): void {
		this.setTheme(DEFAULT_THEME);
		this.setMode(DEFAULT_MODE);
	}
}
